/* eslint-disable react-hooks/exhaustive-deps */
import { SIDEBAR_WIDTH } from "../../ui/SideBar";
import * as React from "react";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";
import ClearIcon from "@mui/icons-material/Clear";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import {
  AppBar,
  Button,
  Grow,
  IconButton,
  Snackbar,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import API from "../../Api/api";
import toast from "react-hot-toast";
import { message } from "antd";
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});

const columns = [
  {
    field: "code",
    headerName: "Code",
    minWidth: 250,
  },
  {
    field: "certificate_number",
    headerName: "Certificate Number",
    minWidth: 170,
    align: "left",
  },
  {
    field: "institution",
    headerName: "Institution",
    minWidth: 170,
    align: "left",
  },
  {
    field: "investment_type",
    headerName: "Investment Type",
    minWidth: 170,
    align: "left",
  },
  {
    field: "regulator",
    headerName: "Regulator",
    minWidth: 170,
    align: "left",
  },
  {
    field: "rate",
    headerName: "Rate",
    minWidth: 170,
    align: "left",
  },
  {
    field: "purchase_date",
    headerName: "Purchase Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "maturity_date",
    headerName: "Maturity Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "tenure",
    headerName: "Tenure",
    minWidth: 170,
    align: "left",
  },

  {
    field: "days_earned",
    headerName: "Days Earned",
    minWidth: 170,
    align: "left",
  },
  {
    field: "days_unearned",
    headerName: "Days Unearned",
    minWidth: 170,
    align: "left",
  },
  {
    field: "cost",
    headerName: "Cost",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "cumulative_interest",
    headerName: "Cumulative Interest",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "interest_unearned",
    headerName: "Interest Unearned",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "impairment",
    headerName: "Impairment",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },

  {
    field: "fair_value",
    headerName: "Fair Value",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "total_interest",
    headerName: "Total Interest",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "interest_charged",
    headerName: "Interest Charged",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "daily_interest",
    headerName: "Daily interest",
    minWidth: 170,
    align: "left",
  },
  {
    field: "rate_type",
    headerName: "Rate type",
    minWidth: 170,
    align: "left",
  },

  {
    field: "status",
    headerName: "Status",
    minWidth: 170,
    align: "left",
  },
];
// Define a function to get unique values from an array of objects
function getUniqueValues(data, extractor) {
  return [...new Set(data.map(extractor).map(JSON.stringify))].map(JSON.parse);
}
function institutionData(institution) {
  return { institution };
}

export default function InvestmentReport() {
  const [openSnack, setOpenSnack] = React.useState(false);
  const [view, setView] = React.useState("");
  const [filterData, setFilterData] = React.useState({
    regulator: "",
    investment_type: "",
    interest_charged_start: "",
    interest_charged_end: "",
    purchased_start: "",
    purchased_end: "",
    maturity_start: "",
    maturity_end: "",
    institution: "",
    tenure_start: "",
    tenure_end: "",
  });
  const totalCost = [];
  const totalinterest_charged = [];
  const totalInterestUnEarned = [];
  const accumInterest = [];
  const fairValue = [];

  function createData(
    id,
    code,
    certificate_number,
    institution,
    investment_type,
    regulator,
    rate,
    purchase_date,
    maturity_date,
    tenure,
    cost,
    impairment,
    total_interest,
    daily_interest,
    rate_type,
  ) {
    //  we are check whether an asset is exhausted or not

    let status = moment(maturity_date) > moment() ? "Active" : "Matured";
    // ----------------------------------------------------------------
    const date2 = moment();
    const date1 = moment(purchase_date);
    let days_earned = date2.diff(date1, "days") + 1;
    let interest_charged = days_earned * daily_interest;
    let days_unearned = tenure - days_earned;
    let cumulative_interest = days_earned * daily_interest;
    let interest_unearned = days_unearned * daily_interest;
    let fair_value =
      rate_type === "interest rate"
        ? cost + cumulative_interest - impairment
        : cost - impairment;
    // ! WE DON'T CHARGE DEPN ON LAND

    // ! Revalued Started here -----------------------//!

    //! ------------Revalued ended here-------------------------///!

    // !------------start------------------------------------
    // checking if the asset has been exhausted;
    // if (cost - cumulative_interest < 1) {
    //   interest_unearned = 0;
    // }
    if (status === "Matured") {
      days_earned = moment(maturity_date).diff(purchase_date, "days");
      days_unearned = 0;

      cumulative_interest = days_earned * daily_interest;
      interest_unearned = days_unearned * daily_interest;
      interest_charged = 0;
      fair_value =
        rate_type === "interest rate"
          ? cost + cumulative_interest - impairment
          : cost - impairment;
    }
    // !------------- Exhausted Checking End---------------------------

    // ! things to do when the interest_charged start date and end date are all selected--------------//Start

    if (filterData.interest_charged_start && filterData.interest_charged_end) {
      if (
        filterData.interest_charged_start &&
        filterData.interest_charged_end &&
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) < moment(filterData.interest_charged_start) &&
        status === "Matured"
      ) {
        cumulative_interest = cost;
        interest_unearned = 0;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }

      if (moment(filterData.interest_charged_end) < moment(purchase_date)) {
        cost = 0;
        fair_value = 0;
        interest_unearned = 0;
        cumulative_interest = 0;
        days_earned = 0;
        days_unearned = 0;
        interest_charged = 0;

        status = "investment was not available then";
      }

      // check if the interest_charged end date is within the exhausted date //! Start------------

      if (
        moment(purchase_date) <= moment(filterData.interest_charged_start) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      // ----------!End!----------------//!

      // we will check if the purchase date is less than the start date and the exhaustion date  is greater than the start date and also the exhaustion date is less than the end date//! start

      if (
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        const diff = moment(maturity_date).diff(
          moment(filterData.interest_charged_start),
          "days",
        );
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );
        //! this is where I did the negative changes
        days_earned = cummDateDiff;
        days_unearned = tenure - cummDateDiff;
        interest_unearned = (tenure - cummDateDiff) * daily_interest;
        cumulative_interest = cummDateDiff * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = diff * daily_interest;
        // ! the change was done here
        // ! I am looking for a scenario where the purchase date is less than the start and the maturity is less than the end
      }

      // ----------------------//!End---------------------
      if (moment(maturity_date) < moment(filterData.interest_charged_start)) {
        interest_unearned = 0;
        cumulative_interest = days_earned * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }
      // if (
      //   moment(purchase_date) < moment(filterData.interest_charged_start) &&
      //   moment(maturity_date) <= moment(filterData.interest_charged_end)
      // ) {
      //   days_earned = tenure;
      // }
      // we will check if the purchase date is greater than the start date and the exhaustion date is greater than the end date//!start
      if (
        moment(purchase_date) > moment(filterData.interest_charged_start) &&
        moment(purchase_date) <= moment(filterData.interest_charged_end) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
        // ! another change too was done here, equal sign was added to the second check
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      if (
        moment(purchase_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        //  we will check if the purchase date is greater than the start date and the exhaustion date is less than the end date;
        // if both the purchase and the exhaustion date are in btn the start and end date;
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days",
        );

        days_earned = cummDateDiff;
        days_unearned = 0;
        interest_unearned = 0;
        cumulative_interest = tenure * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        const diff = moment(maturity_date).diff(moment(purchase_date), "days");
        interest_charged = diff * daily_interest;
      }
    }
    // -----------------------End of instance-------------------//!End
    // ! we will be catching all disposed assets instances here

    //  we will check if the disposal happened before the start date

    // we will check if the disposal date is greater than the start date and is less than or equal to the end date;

    // ! Depn start and depn end.-----------------------// End

    totalCost.push(cost);
    totalinterest_charged.push(interest_charged);
    totalInterestUnEarned.push(interest_unearned);
    accumInterest.push(cumulative_interest);
    fairValue.push(fair_value);
    return {
      id,
      code,
      certificate_number,
      institution,
      investment_type,
      regulator,
      rate,
      purchase_date,
      maturity_date,
      tenure,
      days_earned,
      days_unearned,
      cost,
      cumulative_interest,
      interest_unearned,
      impairment,
      fair_value,
      total_interest,
      interest_charged,
      daily_interest,
      status,
      rate_type,
    };
  }

  const regulators = useSelector((state) => state.regulators);
  const investmentTypes = useSelector((state) => state.investmentTypes);
  const approvedInvestments = useSelector((state) => state.approvedInvestment);

  const [data, setData] = React.useState(approvedInvestments);

  const rows =
    filterData.interest_charged_end && filterData.interest_charged_start
      ? data
          .filter((data) => {
            const purchaseDate = moment(data.purchase_date);
            return (
              // purchaseDate >= moment(filterData.interest_charged_start) &&
              purchaseDate <= moment(filterData.interest_charged_end)
            );
          })
          .map((data) => {
            return createData(
              data._id,
              data.code,
              data.certificate_number,
              data.institution,
              data.investment_type,
              data.regulator,
              data.rate,
              moment(data.purchase_date).format("YYYY-MM-DD"),
              moment(data.maturity_date).format("YYYY-MM-DD"),
              data.tenure,
              data.cost,
              data.impaired_amount,
              data.total_interest,
              data.daily_interest,
              data.rate_type,
            );
          })
      : data.map((data) => {
          return createData(
            data._id,
            data.code,
            data.certificate_number,
            data.institution,
            data.investment_type,
            data.regulator,
            data.rate,
            moment(data.purchase_date).format("YYYY-MM-DD"),
            moment(data.maturity_date).format("YYYY-MM-DD"),
            data.tenure,
            data.cost,
            data.impaired_amount,
            data.total_interest,
            data.daily_interest,
            data.rate_type,
          );
        });

  const [allInvestments, setAllInvestments] =
    React.useState(approvedInvestments); // Separate the original data array

  // const currentDate = moment();

  const filterDate = filterData.interest_charged_end
    ? moment(filterData.interest_charged_end)
    : moment();
  const filterDate2 = filterData.interest_charged_start
    ? moment(filterData.interest_charged_start)
    : moment();

  React.useEffect(() => {
    if (view === "all investments") {
      const allAtiveInvestments = allInvestments.filter(
        (investment) => moment(investment.maturity_date) >= filterDate2,
      );
      setData(allAtiveInvestments);
    } else if (view === "active investments") {
      const activeInvestments = allInvestments.filter(
        (investment) => moment(investment.maturity_date) >= filterDate,
      );
      setData(activeInvestments);
    } else if (view === "exhausted investments") {
      const exhaustedInvestments = allInvestments.filter(
        (investment) => moment(investment.maturity_date) < moment(),
      );
      setData(exhaustedInvestments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    view,
    allInvestments,
    filterData.interest_charged_end,
    filterData.interest_charged_start,
  ]);

  React.useEffect(() => {
    if (!view) {
      const activeInvestments = data.filter(
        (data) => moment(data.maturity_date) > moment(),
      );
      setData(activeInvestments);
    }
  }, [view]);
  const regulator = filterData.regulator
    ? `&regulator=${filterData.regulator}`
    : "";
  const investment_type = filterData.investment_type
    ? `&investment_type=${filterData.investment_type}`
    : "";
  const purchase_date_start = filterData.purchased_start
    ? `&purchase_date[gte]=${filterData.purchased_start}`
    : "";
  const purchase_date_end = filterData.purchased_end
    ? `&purchase_date[lte]=${filterData.purchased_end}`
    : "";
  const expiration_start = filterData.maturity_start
    ? `&maturity_date[gte]=${filterData.maturity_start}`
    : "";
  const expiration_end = filterData.maturity_end
    ? `&maturity_date[lte]=${filterData.maturity_end}`
    : "";
  const institution = filterData.institution
    ? `&institution[eq]=${filterData.institution}`
    : "";
  const tenure_start = filterData.tenure_start
    ? `&tenure[gte]=${+filterData.tenure_start}`
    : "";
  const tenure_end = filterData.tenure_end
    ? `&tenure[lte]=${+filterData.tenure_end}`
    : "";

  const query = `/api/v1/investment?rate_type[ne]=undefined rate&approved=true${regulator}${investment_type}${purchase_date_end}${purchase_date_start}${expiration_start}${expiration_end}${tenure_start}${tenure_end}${institution}`;
  function handleCloseSnack() {
    setOpenSnack(false);
  }
  const fetchInvestment = async () => {
    let fetchingId;
    try {
      if (
        !regulator &&
        !investment_type &&
        !purchase_date_end &&
        !purchase_date_start &&
        !expiration_end &&
        !expiration_start &&
        !tenure_end &&
        !tenure_start &&
        !institution &&
        !filterData.interest_charged_start &&
        !filterData.interest_charged_end
      ) {
        toast.error("Choose at least one filter before generating a report");
        return;
      }
      fetchingId = toast.loading("Fetching data...");
      const res = await API.get(query);
      toast.remove(fetchingId);
      if (Array.isArray(res.data) && res.data.length > 0) {
        setData(res.data);
        setAllInvestments(res.data);
        message.info("Report Successfully generated");
      } else {
        setData([]);
        setOpenSnack(false);
        toast.error("No investments match these filters");
      }
    } catch (error) {
      toast.remove(fetchingId);
      toast.error(error.message);
    }
  };
  const totalInvestmentCost = totalCost.reduce((acc, val) => acc + val, 0);
  const totalInvestmentInterestCharged = totalinterest_charged.reduce(
    (acc, val) => acc + val,
    0,
  );
  const totalInvestmentInterestUnEarned = totalInterestUnEarned.reduce(
    (acc, val) => acc + val,
    0,
  );
  const totalInvestmentAccumInterest = accumInterest.reduce(
    (acc, val) => acc + val,
    0,
  );
  const totalInvestmentFairValue = fairValue.reduce((acc, val) => acc + val, 0);
  function clearFilter() {
    setData(approvedInvestments);
    setAllInvestments(approvedInvestments);
    setFilterData({
      regulator: "",
      investment_type: "",
      interest_charged_start: "",
      interest_charged_end: "",
      purchased_start: "",
      purchased_end: "",
      maturity_start: "",
      maturity_end: "",
      institution: "",
      tenure_start: "",
      tenure_end: "",
    });
    setView("");
    message.info("Filter Cleared");
  }
  const [filteredRows] = React.useState(approvedInvestments);

  const handleFilterModelChange = (newModel) => {
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "contains"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().includes(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "equals"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter(
        (data) =>
          data[fields]?.toString().toLowerCase() === value?.toLowerCase(),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "startsWith"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().startsWith(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "endsWith"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        data[fields]?.toString().toLowerCase().endsWith(value?.toLowerCase()),
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isEmpty"
    ) {
      const fields = newModel?.items[0]?.field;
      const filterData = filteredRows.filter(
        (data) => data[fields] === null || "" || undefined,
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isNotEmpty"
    ) {
      const fields = newModel?.items[0]?.field;
      const filterData = filteredRows.filter(
        (data) => data[fields] != null || "" || undefined,
      );
      setData(filterData);
    }
    if (
      newModel &&
      newModel?.items[0]?.field &&
      newModel?.items[0]?.value &&
      newModel?.items[0]?.operator === "isAnyOf"
    ) {
      const fields = newModel?.items[0]?.field;
      const value = newModel?.items[0]?.value;
      const filterData = filteredRows.filter((data) =>
        value?.includes(data[fields]),
      );
      setData(filterData);
    }
  };
  const dataArr = [];

  const handleOnCellClick = (data) => {
    const rowId = data?.row.id;

    if (data?.formattedValue === "no" && !dataArr.includes(rowId)) {
      dataArr.push(rowId);
    } else if (data?.formattedValue === "yes" && dataArr.includes(rowId)) {
      const index = dataArr.indexOf(rowId);
      dataArr.splice(index, 1);
    }
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        style={{ backgroundColor: "#f8f8f8", color: "#000", fontSize: "12px" }}
      >
        <GridToolbar style={{ color: "#000", fontSize: "12px" }} />
        {dataArr.length > 0 && (
          <Grow in={dataArr.length > 0} timeout={1000}>
            <div>
              <Tooltip title="remove selected">
                <IconButton onClick={removeSelected}>
                  <ClearIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Keep Selected only">
                <IconButton onClick={keepSelected}>
                  <DoneAllIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Grow>
        )}
      </GridToolbarContainer>
    );
  }
  function keepSelected() {
    const filter = data.filter((data) => dataArr.includes(data._id));
    setData(filter);
  }
  function removeSelected() {
    const filter = data.filter((data) => !dataArr.includes(data._id));
    setData(filter);
  }

  const uniqueInstitutionValues = getUniqueValues(approvedInvestments, (d) =>
    institutionData(d.institution),
  );

  return (
    <div>
      <Snackbar
        open={openSnack}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleCloseSnack}
        message="Loading Data...."
      />
      <Paper
        elevation={0}
        style={{
          backgroundColor: "transparent",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          elevation={16}
          style={{
            fontSize: "14px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "row",
            // alignItems: "center",
            justifyContent: "space-between",
            height: "95px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", rowGap: 9 }}>
            <FormControl size="small" sx={{ m: 1, width: 140 }}>
              <InputLabel size="small" id="demo-simple-select-standard-label">
                Regulator
              </InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterData.regulator}
                onChange={(e) =>
                  setFilterData({ ...filterData, regulator: e.target.value })
                }
                label="Category"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {regulators.map((reg) => (
                  <MenuItem key={reg._id} value={reg.regulator}>
                    {reg.regulator}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ m: 1, width: 140 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Investment type
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterData.investment_type}
                onChange={(e) =>
                  setFilterData({
                    ...filterData,
                    investment_type: e.target.value,
                  })
                }
                label="Category"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {investmentTypes.map((invest) => (
                  <MenuItem key={invest._id} value={invest.investment_type}>
                    {invest.investment_type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
              }}
              htmlFor="start-date"
            >
              Interest charged start
            </label>
            <input
              value={filterData.interest_charged_start}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  interest_charged_start: e.target.value,
                })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="start-date"
              type="date"
              size={"large"}
              name="start-date"
            />

            <label
              style={{ fontWeight: "bold", fontSize: "14px" }}
              htmlFor="end-date"
            >
              Interest charged end
            </label>
            <input
              value={filterData.interest_charged_end}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  interest_charged_end: e.target.value,
                })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="end-date"
              type="date"
              size="small"
              name="end-date"
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "bold", fontSize: "14px" }}
              htmlFor="acq-start-date"
            >
              Purchased start
            </label>
            <input
              value={filterData.purchased_start}
              onChange={(e) =>
                setFilterData({
                  ...filterData,
                  purchased_start: e.target.value,
                })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="acq-start-date"
              type="date"
              size="small"
            />
            <label
              style={{ fontWeight: "bold", fontSize: "14px" }}
              htmlFor="acq-start-date"
            >
              Purchased end
            </label>
            <input
              value={filterData.purchased_end}
              onChange={(e) =>
                setFilterData({ ...filterData, purchased_end: e.target.value })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "bold", fontSize: "14px" }}
              htmlFor="acq-start-date"
            >
              Maturity start
            </label>
            <input
              value={filterData.maturity_start}
              onChange={(e) =>
                setFilterData({ ...filterData, maturity_start: e.target.value })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
            <label
              style={{ fontWeight: "bold", fontSize: "14px" }}
              htmlFor="acq-start-date"
            >
              Maturity end
            </label>
            <input
              value={filterData.maturity_end}
              onChange={(e) =>
                setFilterData({ ...filterData, maturity_end: e.target.value })
              }
              style={{
                borderRadius: "5px",

                border: "1px solid #3D4F58",
              }}
              id="acq-end-date"
              type="date"
              size="small"
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <FormControl size="small" sx={{ m: 1, width: 140 }}>
            <InputLabel size="small" id="demo-simple-select-standard-label">
              Institution
            </InputLabel>
            <Select
              size="small"
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={filterData.institution}
              onChange={(e) =>
                setFilterData({ ...filterData, institution: e.target.value })
              }
              label="Category"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {uniqueInstitutionValues.map((inst) => (
                <MenuItem key={inst.institution} value={inst.institution}>
                  {inst.institution}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "105px",
            }}
          >
            <TextField
              style={{ width: "88px" }}
              type="number"
              size="small"
              label="tenure start"
              placeholder=">="
              InputLabelProps={{ shrink: true }}
              value={filterData.tenure_start}
              onChange={(e) =>
                setFilterData({ ...filterData, tenure_start: e.target.value })
              }
            />
            <TextField
              style={{ width: "88px" }}
              type="number"
              size="small"
              label="tenure end"
              placeholder="<="
              InputLabelProps={{ shrink: true }}
              value={filterData.tenure_end}
              onChange={(e) =>
                setFilterData({ ...filterData, tenure_end: e.target.value })
              }
            />
          </div>

          <FormControl size="small" sx={{ width: 130, ml: 12 }}>
            <InputLabel id="demo-simple-select-standard-label">View</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              value={view}
              onChange={(e) => setView(e.target.value)}
              id="demo-simple-select-standard"
              label="Category"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="active investments">Active Investments</MenuItem>
              <MenuItem value="exhausted investments">
                Matured Investments
              </MenuItem>
              <MenuItem value="all investments">All Investments</MenuItem>
            </Select>
          </FormControl>
          <div>
            <Button
              onClick={fetchInvestment}
              size="small"
              variant="contained"
              style={{
                margin: "5px",
                height: "35px",
                textTransform: "capitalize",
              }}
            >
              Generate Report
            </Button>

            <Button
              onClick={clearFilter}
              size="small"
              variant="contained"
              style={{
                backgroundColor: "#f47373",
                height: "35px",
                marginRight: "5px",
                textTransform: "capitalize",
              }}
            >
              Clear Filter
            </Button>
          </div>
        </div>
      </Paper>
      <Paper sx={{ width: "100%", height: "60vh", paddingBottom: "50px" }}>
        <DataGrid
          style={{ height: "55vh", fontSize: "12px" }}
          columns={columns}
          rows={rows}
          {...rows}
          slots={{ toolbar: CustomToolbar }}
          checkboxSelection
          onCellClick={handleOnCellClick}
          onFilterModelChange={handleFilterModelChange}
          density="compact"
        />
        <AppBar
          position="fixed"
          style={{
            backgroundColor: "#f8f8f8",
            color: "#000000",
            height: "40px",
          }}
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              marginLeft: SIDEBAR_WIDTH,
              height: "40px",
              marginTop: "-15px",
            }}
          >
            <Typography
              style={{
                backgroundColor: "#fff",
                border: "0.5px solid #000000",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              <strong>Cost:</strong>{" "}
              {currencyFormatter.format(totalInvestmentCost)}
            </Typography>
            <Typography
              style={{
                backgroundColor: "#fff",
                border: "0.5px solid #000000",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              <strong>Accum. Interest:</strong>{" "}
              {currencyFormatter.format(totalInvestmentAccumInterest)}
            </Typography>
            <Typography
              style={{
                backgroundColor: "#fff",
                border: "0.5px solid #000000",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              <strong>Interest Unearned:</strong>{" "}
              {currencyFormatter.format(totalInvestmentInterestUnEarned)}
            </Typography>
            <Typography
              style={{
                backgroundColor: "#fff",
                border: "0.5px solid #000000",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              <strong>Interest charged:</strong>{" "}
              {currencyFormatter.format(totalInvestmentInterestCharged)}
            </Typography>
            <Typography
              style={{
                backgroundColor: "#fff",
                border: "0.5px solid #000000",
                padding: "2px",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              <strong>Fair Value:</strong>{" "}
              {currencyFormatter.format(totalInvestmentFairValue)}
            </Typography>
          </Toolbar>
        </AppBar>
      </Paper>
    </div>
  );
}
